// src/components/Header/HelpModal.tsx
import React from 'react';
import { X, Book, MessageCircle, FileText, Video } from 'lucide-react';
import './Modals.scss';

interface HelpModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const HelpModal: React.FC<HelpModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  const helpResources = [
    {
      icon: <Book className="help-icon" />,
      title: 'Documentation',
      description: 'Browse our comprehensive guides and tutorials',
      link: '#'
    },
    {
      icon: <Video className="help-icon" />,
      title: 'Video Tutorials',
      description: 'Watch step-by-step video guides',
      link: '#'
    },
    {
      icon: <MessageCircle className="help-icon" />,
      title: 'Contact Support',
      description: 'Get help from our support team',
      link: '#'
    },
    {
      icon: <FileText className="help-icon" />,
      title: 'Release Notes',
      description: 'See what\'s new in the latest version',
      link: '#'
    }
  ];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content help-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Help & Support</h2>
          <button className="modal-close" onClick={onClose}>
            <X size={20} />
          </button>
        </div>
        <div className="modal-body">
          <div className="help-resources">
            {helpResources.map((resource, index) => (
              <a key={index} href={resource.link} className="help-resource-card">
                {resource.icon}
                <div className="help-resource-content">
                  <h3>{resource.title}</h3>
                  <p>{resource.description}</p>
                </div>
              </a>
            ))}
          </div>

          <div className="help-shortcuts">
            <h3>Keyboard Shortcuts</h3>
            <div className="shortcuts-list">
              <div className="shortcut-item">
                <span className="shortcut-key">Ctrl + K</span>
                <span className="shortcut-desc">Quick Search</span>
              </div>
              <div className="shortcut-item">
                <span className="shortcut-key">Ctrl + N</span>
                <span className="shortcut-desc">New Task</span>
              </div>
              <div className="shortcut-item">
                <span className="shortcut-key">Ctrl + /</span>
                <span className="shortcut-desc">Toggle Sidebar</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
